// extracted by mini-css-extract-plugin
module.exports = {"restaurantLayout":"RestaurantLayout_restaurantLayout__3oN26","RestaurantLeft":"RestaurantLayout_RestaurantLeft__348Qk","RestaurantRight":"RestaurantLayout_RestaurantRight__2-TmS"};